import { render, staticRenderFns } from "./EditRevision.vue?vue&type=template&id=94a2cbca&"
import script from "./EditRevision.vue?vue&type=script&lang=js&"
export * from "./EditRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports